import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { SettingsHeaderProps } from '@components/settings/v2/common/SettingsHeader';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { SCREEN_PADDING_HORIZONTAL } from '@helpers';
import { HEADER_EDIT_BUTTON_CONFIG } from '@components/settings/v2/common/SettingsHeader/constants';

interface HeaderEditButtonProps extends Pick<SettingsHeaderProps, 'C' | 'action' | 'actionConfig'> {}

const HeaderEditButton: FC<HeaderEditButtonProps> = ({ C, action, actionConfig }) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginRight: scale(SCREEN_PADDING_HORIZONTAL - HEADER_EDIT_BUTTON_CONFIG.paddingHorizontal),
      }}
    >
      <TouchableElement onPress={action}>
        {({ boxStyle, pressHoverColor }) => (
          <View
            style={[
              boxStyle,
              {
                backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
                paddingHorizontal: scale(HEADER_EDIT_BUTTON_CONFIG.paddingHorizontal),
                paddingVertical: scale(7),
                borderRadius: scale(SCREEN_BORDER_RADIUS),
              },
            ]}
          >
            <Text
              style={[
                font.Body,
                {
                  color: C('Link/Light/Primary'),
                  ...actionConfig,
                },
              ]}
            >
              {i18n.t('Edit')}
            </Text>
          </View>
        )}
      </TouchableElement>
    </View>
  );
};

export default HeaderEditButton;
